var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-input',{attrs:{"title":"ПОИСК ЗАПРОСА:","placeholder":"введите запрос","form-group":"","form-group-margin-bottom":"","input-group":"","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"addonRight",fn:function(){return [_c('i',{staticClass:"fa fa-search"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }